<template>
  <div class="chosen-filters" v-if='Object.keys(filters).length > 0'>
    <ul>
      <li v-for='(v, k) in filters' :key='k'>
        <span @click.prevent='currentFilter = queryToFilter(k)'>
          {{ $t('root.filters.' + queryToFilter(k)) }}
          <strong>{{ valueToFilter(k, v) }}</strong>
        </span>

        <span @click.prevent.stop='resetFilter(k)' class="remove-item">x</span>

        <div class="edit-filter" v-show='currentFilter == queryToFilter(k)'>
          <component :is="'filter-items-by-' + queryToFilter(k)" :folder='folder' @cancel='closeDropdown' />
          <span @click.prevent.stop='currentFilter = null' class="close-item">x</span>
        </div>
      </li>
    </ul>

    <button @click.prevent='resetFilters' class="remove-filters own-tooltip own-tooltip-left" :data-tooltip="$t('root.filters.remove_all_filters')">
      <i class="fas fa-trash"></i>
    </button>
  </div>
</template>

<script>
  import {mimeTypeToString} from '../../../../mime_type'

  import _filter_items_by_shared from './_filter_by_shared'
  import _filter_items_by_version from './_filter_by_version'
  import _filter_items_by_star from './_filter_by_star'
  import _filter_items_by_type from './_filter_by_type'
  import _filter_items_by_contact from './_filter_by_contact'
  import _filter_items_by_checklist from './_filter_by_checklist'
  import _filter_items_by_ocr from './_filter_by_ocr'
  import _filter_items_by_subscription from './_filter_by_subscription'
  import _filter_items_by_mime from './_filter_by_mime'
  import _filter_items_by_exp_status from './_filter_by_exp_status'
  import _filter_items_by_exp_date from './_filter_by_exp_date'
  import _filter_items_by_size from './_filter_by_size'
  import _filter_items_by_progress from './_filter_by_progress'
  import _filter_items_by_tag from './_filter_by_tag'
  import _filter_items_by_product from './_filter_by_product'
  import _filter_items_by_document from './_filter_by_document'
  import _filter_items_by_uploaded_from from './_filter_by_uploaded_from'
  import _filter_items_by_folder from './_filter_by_folder'

  export default {
    components: {
      'filter-items-by-shared_eq': _filter_items_by_shared,
      'filter-items-by-starred_eq': _filter_items_by_star,
      'filter-items-by-versions_id_null': _filter_items_by_version,
      'filter-items-by-versions_id_not_null': _filter_items_by_version,
      'filter-items-by-klass_eq': _filter_items_by_type,
      'filter-items-by-created_at_gteq': _filter_items_by_type,
      'filter-items-by-contact_id_in': _filter_items_by_contact,
      'filter-items-by-contact_id_not_in': _filter_items_by_contact,
      'filter-items-by-belongs_to_checklist_eq': _filter_items_by_checklist,
      'filter-items-by-ocr_content_present': _filter_items_by_ocr,
      'filter-items-by-subscribed_eq': _filter_items_by_subscription,
      'filter-items-by-mime_type_in': _filter_items_by_mime,
      'filter-items-by-mime_type_not_in': _filter_items_by_mime,
      'filter-items-by-status_in': _filter_items_by_exp_status,
      'filter-items-by-status_not_in': _filter_items_by_exp_status,
      'filter-items-by-expiration_date_gteq': _filter_items_by_exp_date,
      'filter-items-by-expiration_date_lteq': _filter_items_by_exp_date,
      'filter-items-by-size_gteq': _filter_items_by_size,
      'filter-items-by-size_lteq': _filter_items_by_size,
      'filter-items-by-checklist_progress_gteq': _filter_items_by_progress,
      'filter-items-by-checklist_progress_lteq': _filter_items_by_progress,
      'filter-items-by-tags_id_in': _filter_items_by_tag,
      'filter-items-by-tags_id_not_in': _filter_items_by_tag,
      'filter-items-by-products_id_in': _filter_items_by_product,
      'filter-items-by-products_id_not_in': _filter_items_by_product,
      'filter-items-by-document_types_id_in': _filter_items_by_document,
      'filter-items-by-document_types_id_not_in': _filter_items_by_document,
      'filter-items-by-uploaded_from_in': _filter_items_by_uploaded_from,
      'filter-items-by-uploaded_from_not_in': _filter_items_by_uploaded_from,
      'filter-items-by-breadcrumbs_jcont': _filter_items_by_folder,
      'filter-items-by-breadcrumbs_not_jcont': _filter_items_by_folder,
    },
    props: {
      folder: {
        type: Object,
        default: () => { return {} },
      },
    },
    created() {
      this.loadFilterData()
    },
    watch: {
      query() {
        this.currentFilter = null
        this.loadFilterData()
      }
    },
    data() {
      return {
        currentFilter: null,
        contacts: [],
        tags: [],
        products: [],
        documents: [],
        folders: [],
        users: [],
      }
    },
    computed: {
      filters() {
        const f = {}
        Object.keys(this.query).forEach((k) => {
          if (k.indexOf('filters') >= 0 && k.indexOf('filters[s]') < 0)
            f[k] = this.query[k]
        })
        return f
      },
      contactIds() {
        return this.query['filters[contact_id_in]'] || this.query['filters[contact_id_not_in]']
      },
      userIds() {
        return this.query['filters[deleted_by_in]'] || this.query['filters[deleted_by_not_in]']
      },
      tagIds() {
        return this.query['filters[tags_id_in]'] || this.query['filters[tags_id_not_in]']
      },
      productIds() {
        return this.query['filters[products_id_in]'] || this.query['filters[products_id_not_in]']
      },
      documentIds() {
        return this.query['filters[document_types_id_in]'] || this.query['filters[document_types_id_not_in]']
      },
      folderIds() {
        return this.query['filters[breadcrumbs_jcont]'] || this.query['filters[breadcrumbs_not_jcont]']
      },
    },
    methods: {
      queryToFilter(f) {
        return f.replace(/filters\[|\]/g, '')
      },
      valueToFilter(f, v) {
        if (f == 'filters[tags_id_in]' || f == 'filters[tags_id_not_in]')
          return this.intersectAndFormat(this.tags, v)
        else if (f == 'filters[deleted_by_in]' || f == 'filters[deleted_by_not_in]')
          return this.intersectAndFormat(this.users, v)
        else if (f == 'filters[contact_id_in]' || f == 'filters[contact_id_not_in]')
          return this.intersectAndFormat(this.contacts, v)
        else if (f == 'filters[products_id_in]' || f == 'filters[products_id_not_in]')
          return this.intersectAndFormat(this.products, v)
        else if (f == 'filters[document_types_id_in]' || f == 'filters[document_types_id_not_in]')
          return this.intersectAndFormat(this.documents, v)
        else if (f == 'filters[breadcrumbs_jcont]' || f == 'filters[breadcrumbs_not_jcont]')
          return this.intersectAndFormat(this.folders, v)
        else if (f == 'filters[status_in]' || f == 'filters[status_not_in]')
          return this.formatExpStatus(v)
        else if (f == 'filters[mime_type_in]' || f == 'filters[mime_type_not_in]')
          return this.formatMime(v)
        else if (f == 'filters[uploaded_from_in]' || f == 'filters[uploaded_from_not_in]')
          return this.formatUploadedFrom(v)
        else if (Number(v))
          return v
        else if (Date.parse(v))
          return this.formatDate(v)
        else
          return this.$t('root.filters.' + v)
      },
      resetFilter(f) {
        let newQuery = Object.assign({}, this.query)

        delete newQuery[f]

        if (Object.keys(this.filters).length == 1)
          delete newQuery['parent_id']

        this.$router.push({ query: newQuery })
      },
      resetFilters() {
        this.$router.push({ query: {} })
      },
      intersectAndFormat(resources, v) {
        const ids = Array.isArray(v) ? v.map(x => parseInt(x)) : [parseInt(v)]
        return resources.filter(x => ids.indexOf(x.id) >= 0).map(x => x.name).join(', ')
      },
      formatExpStatus(v) {
        const arr = Array.isArray(v) ? v.map(x => this.expStatusTranslations[x]) : [this.expStatusTranslations[v]]
        return arr.join(', ')
      },
      formatMime(v) {
        if (!Array.isArray(v))
          return mimeTypeToString(v)

        const mimes = new Set()
        v.forEach(x => mimes.add(mimeTypeToString(x)))
        return Array.from(mimes).join(', ')
      },
      formatUploadedFrom(v) {
        if (!Array.isArray(v))
          return this.$t('root.filters.' + v)

        return v.map(x =>  this.$t('root.filters.' + x)).join(', ')
      },
      closeDropdown() {
        this.currentFilter = null
      },
      loadFilterData() {
        if (this.contactIds)
          this.listStore.getContacts({ 'filters[id_in]': this.contactIds }).then(({data}) => this.contacts = data)

        if (this.tagIds)
          this.listStore.getTags({ 'filters[id_in]': this.tagIds }).then(({data}) => this.tags = data)

        if (this.productIds)
          this.listStore.getProducts({ 'filters[id_in]': this.productIds }).then(({data}) => this.products = data)

        if (this.documentIds)
          this.listStore.getDocumentTypes({ 'filters[id_in]': this.documentIds }).then(({data}) => this.documents = data)

        if (this.folderIds)
          this.listStore.getFolders({ 'filters[id_in]': this.folderIds }).then(({data}) => this.folders = data)

        if (this.userIds)
          this.listStore.getUsers({ 'filters[id_in]': this.userIds }).then(({data}) => this.users = data)
      },
    }
  }
</script>

<style lang='sass' scoped>
  .chosen-filters
    float: left
    width: 100%
    margin: 10px 0
    display: flex
    position: relative
    ul
      margin: 0
      padding: 0
      list-style: none
      display: flex
      flex-wrap: wrap
      li
        border: 1px solid #c6c6c6
        border-radius: 3px
        width: auto
        padding: 3px 5px
        cursor: pointer
        margin-right: 10px
        position: relative
        margin-bottom: 5px
        .remove-item
          font-size: 18px
          padding-left: 10px
    .edit-filter
      position: absolute
      background: #fff
      border: 1px solid #c8c8c8
      top: 40px
      left: 0
      border-radius: 3px
      z-index: 1000
      padding: 10px
      &:after, &:before
        bottom: 100%
        left: 50%
        border: solid transparent
        content: ""
        height: 0
        width: 0
        position: absolute
        pointer-events: none
      &:after
        border-color: rgba(255, 255, 255, 0)
        border-bottom-color: #fff
        border-width: 10px
        margin-left: -10px
      &:before
        border-color: rgba(200, 200, 200, 0)
        border-bottom-color: #c8c8c8
        border-width: 13px
        margin-left: -13px
      .close-item
        position: absolute
        top: -2px
        right: 12px
        font-size: 18px
        cursor: pointer
    .remove-filters
      border: none
      background: #5072ED
      border-radius: 50%
      width: 25px
      height: 25px
      margin-top: 2px
      i
        color: #fff
</style>
